import { cached, tracked } from '@glimmer/tracking';
import ApplicationInstance from '@ember/application/instance';
import { type Registry as Services, service } from '@ember/service';
import { TaxRateType } from 'uplisting-frontend/models/tax';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { TaxValidation } from 'uplisting-frontend/validations';

export default class TaxRepositoryService extends BaseRepositoryService<
  ModelRegistry['tax']
> {
  @service intl!: Services['intl'];

  recordName = 'tax';
  implementMethods = ['createRecord', 'findAll', 'peekAll', 'buildChangeset'];

  validation = TaxValidation;

  @tracked defaultTaxOption!: ModelRegistry['tax'];

  constructor(appInstance: ApplicationInstance) {
    super(appInstance);

    if (!this.defaultTaxOption) {
      this.defaultTaxOption = this.createRecord({
        type: this.intl.t('tax.no_tax'),
      });
    }
  }

  get defaultParams() {
    return {
      rateType: TaxRateType.exclusive,
    };
  }

  @cached
  get taxOptions(): ModelRegistry['tax'][] {
    return this.peekAll();
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/tax': TaxRepositoryService;
  }
}
